import { render, staticRenderFns } from "./AddNewAddress.vue?vue&type=template&id=6961d063"
import script from "./AddNewAddress.vue?vue&type=script&lang=js"
export * from "./AddNewAddress.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports